<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12 col-12 col-sm-12 col-md-12 my-auto">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">Vehicle Maintenance</h1>
        <div>
          <button
            *ngIf="isAdmin || isSuperSupervisor"
            class="btn btn-sm me-2 gap-2 lr-btn"
            mat-raised-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            (click)="exportToExcel()"
          >
            Export
          </button>
          <button
            class="btn btn-dark btn-sm"
            matTooltip="Add Maintenance"
            matTooltipPosition="left"
            mat-raised-button
            routerLink="../AddvehicleMaintenence"
          >
            <i class="fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="filter-flex">
        <!-- Search Input -->
        <div
          class="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 d-flex align-items-center h-100"
        >
          <!-- <div class="d-flex gap-3 flex-wrap"> -->
          <div class="form-group accountsinp mb-3 flex-fill">
            <label for="search">Search</label>

            <input
              class="search-box form-control"
              #searchInput
              placeholder="Search"
              type="text"
              (keyup)="filterData(searchInput.value)"
            />
          </div>
          <!-- </div> -->
        </div>
        <!-- Date Filters -->

        <div class="col-lg-4 col-md-6 col-sm-12 col-12">
          <div class="d-flex gap-3 flex-wrap">
            <!-- From Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="fromDate">From Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="fromDate"
                (change)="onDateChange($event, 'from')"
              />
            </div>

            <!-- To Date -->
            <div class="form-group accountsinp mb-3 flex-fill">
              <label for="toDate">To Date</label>
              <input
                type="date"
                class="form-control shadow-none"
                id="toDate"
                (change)="onDateChange($event, 'to')"
              />
            </div>
          </div>
        </div>

        <!-- Clear Filters Button -->
        <div class="col-sm-1 d-flex align-items-center h-100">
          <button
            class="clearFilterBtn"
            mat-raised-button
            (click)="clearFilters()"
          >
            <img src="/assets/images/svg/ClearFilter.svg" alt="clear" />
          </button>
        </div>
      </div>

      <div class="col-md-12 table-responsive">
        <table
          mat-table
          [dataSource]="dataSource"
          matSort
          matSortActive="expenseDate"
          matSortDirection="desc"
          class="row-border hover tablelist"
        >
          <ng-container matColumnDef="SupervisorName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Supervisor Name
            </th>
            <td mat-cell *matCellDef="let user; let i = index">
              {{ user?.supervisor?.full_name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="expenseSubCategory">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Expense Category
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user?.subCategory?.expenseSubCategory }}
            </td>
          </ng-container>
          <!-- {{user.expenseSubCategory!='null'?user.expenseSubCategory:''}} -->
          <ng-container matColumnDef="companyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Company Name
            </th>
            <td mat-cell *matCellDef="let user">{{ user.companyName }}</td>
          </ng-container>

          <ng-container matColumnDef="totalExpenseAmount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Expense Amount
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.totalExpenseAmount }}
            </td>
          </ng-container>

          <ng-container matColumnDef="expenseDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Expense Date
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.expenseDate | date : "yyyy-MM-dd" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="expenseDescription">
            <th mat-header-cell *matHeaderCellDef>Expense Description</th>
            <td
              mat-cell
              *matCellDef="let user"
              matTooltip="{{
                user.expenseDescription.length > 30
                  ? user.expenseDescription
                  : ''
              }}"
            >
              {{
                user.expenseDescription.length > 30
                  ? user.expenseDescription.slice(0, 30) + "..."
                  : user.expenseDescription
              }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              Action
            </th>
            <td mat-cell *matCellDef="let user">
              <div
                class="d-flex justify-content-center align-items-center gap-3"
              >
                <button
                  class="btn btn-block p-0 shadow-none"
                  [routerLink]="[
                    '/superAdmin/miscellaneous-expenses/viewMaintaince',
                    user._id
                  ]"
                >
                  <i class="fa-solid fa-eye"></i>
                </button>
                <button
                  *ngIf="isAdmin || isSuperSupervisor"
                  [routerLink]="[
                    '/superAdmin/miscellaneous-expenses/editVehicleMaintenance',
                    user._id
                  ]"
                  class="btn btn-block p-0 shadow-none"
                >
                  <i matTooltip="Edit" class="fa-solid fa-pen-to-square"></i>
                </button>
                <button
                  *ngIf="isAdmin"
                  class="btn btn-block p-0 shadow-none"
                  (click)="deleteExpense(user._id)"
                >
                  <i
                    matTooltip="Delete"
                    class="fa fa-trash"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageIndex]="currentPage - 1"
        [pageSize]="limit"
        [pageSizeOptions]="[5, 10, 25, 100]"
        showFirstLastButtons
        (page)="onPageChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
